// Entry point for the build script in your package.json

// App-wide librairies
import './lib/rails';
import './lib/jquery';
import * as bootstrap from 'bootstrap';
import './lib/toastr';
import select2 from 'select2';
import './channels';

// Stimulus
import './controllers';

Rails.start();
select2();

// *****************************************************************************
//                   Please do not add anything more here.
//         Use either an import, or scope your JS to the view it's used.
// *****************************************************************************
$(document).ready(function () {
  $('.js-example-basic-single').select2();
  $('.auto-input').on('change', function () {
    var form = $(this).parents('form')[0];

    Rails.fire(form, 'submit');
  });

  // Initialize Bootstrap tooltips
  var tooltipTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="tooltip"]')
  );
  tooltipTriggerList.map(function (tooltipTriggerEl) {
    new bootstrap.Tooltip(tooltipTriggerEl);
  });

  // Prevent dropdown menu presents in responsive table from provoking unwanted scroll on responsive views.
  $('.table-responsive').on('show.bs.dropdown', function (e) {
    offset = $(e.relatedTarget).offset();

    heigth = $(e.relatedTarget).outerHeight();

    $(e.relatedTarget)
      .next('.dropdown-menu')
      .addClass('dropdown-menu-in-table')
      .appendTo('body')
      .css({ display: 'block', top: offset.top + heigth, left: offset.left });
  });

  $('body').on('hide.bs.dropdown', function (e) {
    $(this)
      .find('.dropdown-menu-in-table')
      .removeClass('dropdown-menu-in-table')
      .css({ display: '', top: '', left: '' })
      .appendTo($(e.relatedTarget).parent());
  });
});
